import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {
	windowOpen,
	toUrl,
	goUrls,
	toLive800,goBackNuxt
} from "@/assets/js/common.js";
import request from './axios'
import utils from '@/assets/js/utils'
import {
	encryptByDES,
	decryptByDES
} from '@/assets/js/3DES.js';
import {
	Message,
	MessageBox
} from 'element-ui';
import vipTan from "@/components/vipTan/vipTan";
import JsonExcel from 'vue-json-excel'
// main.js
import htmlToPdf from '@/assets/js/htmlToPdf'
Vue.use(htmlToPdf)
Vue.component('downloadExcel', JsonExcel)
//定义一个新的Message方法
let messageInstance = null;
const $message = options => {
	if (messageInstance) {
		//判断是否有提示框，有则关闭
		messageInstance.close();
	}
	messageInstance = Message(options);
	return messageInstance;
};

//重写方法
['success', 'warning', 'info', 'error'].forEach(type => {
	$message[type] = options => {
		let offset = window.outerHeight / 2
		if (typeof options === 'string') {
			options = {
				message: options,
				offset: offset
			};
		}
		options.type = type;
		options.duration = 2000; 
		return Message(options);
	};
});

Vue.config.productionTip = false

Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.directive('title', { //单个修改标题
	inserted: function(el) {
		document.title = el.dataset.title
	}
})

Vue.prototype.$windowOpen = windowOpen //打开新页面
Vue.prototype.$toUrl = toUrl //打开页面 $toUrl(url, parameters) url路由name，parameters参数obj格式
Vue.prototype.$goUrls = goUrls //打开页面 $toUrl(url, id,parameters) url路由name，id隐藏参数名，parameters参数obj格式
Vue.prototype.$request = request //请求拦截
Vue.prototype.$utils = utils //请求拦截
Vue.prototype.cookie = VueCookie
Vue.prototype.$message = $message; //将$message挂载到this上
Vue.prototype.$message.closeAll = Message.closeAll;
Vue.prototype.$MessageBox = MessageBox; //将$message挂载到this上
Vue.prototype.$encryptByDES = encryptByDES
Vue.prototype.$decryptByDES = decryptByDES
Vue.prototype.$vipModal = vipTan.install
Vue.prototype.$toLive800 = toLive800
Vue.prototype.$goBackNuxt = goBackNuxt



var threshold = 200;
// let timer1 = setInterval(function() {
// 	//当浏览器窗口宽度或高度与页面的宽度和高度的差值大于100的时候触发页面刷新
// 	if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight >
// 		threshold) {
// 		// 刷新页面；
// 		window.location.reload()
// 		alert('请关闭控制台重新输入地址进入网站');
// 	}
// })
// document.onkeydown = () => {
// 	//禁用F12
// 	if (window.event && window.event.keyCode == 123) {
// 		return false;
// 		//禁用ctrl+shift+i,
// 	} else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
// 		return false;
// 		//屏蔽Shift+F10
// 	} else if (window.event.shiftKey && window.event.keyCode == 121) {
// 		return false;
// 	}
// };

//设置meta
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

export default new Vue({
	router,
	store,
	render: h => h(App),
  // 预渲染
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')
